// @ts-check
import { Box, Button, Link } from '~/design-system';
import { Trans } from '@lingui/macro';
import { useCommonLinks } from '../../pages/imports/_config';
import MailToButton from '../MailToButton';
import Layout from '../Layout/Layout';
import PageSubtitle from '../Layout/PageSubtitle';
import PageTitle from '../Layout/PageTitle';
import { Text } from '@bottlebooks/gatsby-design-system';
import React from 'react';

/**
 * This page shouldn't render. It means that the state is not handled.
 * @param {Object} props
 * @param {Object} [props.importData] - the import data
 * @param {{message?:string, networkError?:{statusCode?:number}}} [props.error] - the error
 */
export default function DefaultImportStateErrorPage({
  importData,
  error = {},
}) {
  const link = useCommonLinks();

  const { message, networkError } = error;
  return (
    <Layout>
      <PageTitle>
        <Trans>Something is wrong</Trans>
      </PageTitle>
      <PageSubtitle>
        {networkError?.statusCode === 504 ? (
          <React.Fragment>
            <Text variant="small">Server took too long to respond.</Text>
            <Text variant="small">
              Consider to reduce the number of rows in your import.
            </Text>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Trans>There is an issue with your import.</Trans>
            <Text variant="small">{message}</Text>
          </React.Fragment>
        )}
      </PageSubtitle>
      {importData?.outputUrl && (
        <Box sx={{ marginTop: 5, textAlign: 'center' }}>
          <Link target="_blank" href={importData.outputUrl}>
            <Trans>Download errors report</Trans>
          </Link>
        </Box>
      )}
      <Box sx={{ marginTop: 5, textAlign: 'center' }}>
        <Button variant="secondary" to={link.root()}>
          <Trans>View imports</Trans>
        </Button>
        <MailToButton
          sx={{ marginLeft: 2 }}
          variant="primary"
          email="support@bottlebooks.me"
          subject="There was an error during import."
        >
          <Trans>Contact support</Trans>
        </MailToButton>
      </Box>
    </Layout>
  );
}
